
export enum TimePeriodType {
    WEEKS = "WEEK",
    MONTHS = "MONTH",
    DAYS = "DAYS",
    HOURS = "HOURS",
    MINUTES = "MINUTES",
    YEARS = "YEARS"
}

export interface TimePeriod {
    start: Date
    end: Date
}

/**
 * key is date as string "{DAY}_{MONTH}_{YEAR}"
 *
 */
export type DateMap<T> = { [ key: string ]: T }

/**
 * returns the time period of the given date and type
 * 
 * @param { Date } date 
 * @param { TimePeriodType } type defaults to WEEKS
 * @returns { TimePeriod }
 */
export const getTimePeriodFromDate = ( date: Date, type: TimePeriodType = TimePeriodType.WEEKS ): TimePeriod => {
    switch( type ) {
        case TimePeriodType.WEEKS:
            const firstDayOfWeek = date.getDate() - date.getDay() + 1;
            const lastDayOfWeek = firstDayOfWeek + 6;
            return {
                start: new Date(  date.setDate( firstDayOfWeek ) ),
                end: new Date( date.setDate( lastDayOfWeek ) )
            };
        default:
            return { start: new Date(), end: new Date() };
    }
};